import React from 'react'

export const Footer = () => {
  return (
    <div className='h-[7vh] bg-primary w-full text-white'>
      <div className='flex items-center justify-center h-full w-full text-xl '><em className='font-bold '>Contact for support: </em> 
      <span className="ml-1">donggiaodang@gmail.com</span>
      </div>
    </div>
  )
}
